<script setup lang="ts">
import router from "@/router";
import { computed } from "vue";
import { RouterLink } from "vue-router";

const props = defineProps<{
  text?: string;
  icon: AwesomeIconName;
  badge?: string;
  link: string;
  iconColor?: string;
  selected?: boolean | "auto";
}>();

const isSelected = computed(() => {
  if (props.selected === "auto") {
    return router.currentRoute.value.path.startsWith(props.link);
  } else {
    return props.selected;
  }
});
</script>

<template>
  <div class="my-px grow">
    <RouterLink :to="link">
      <div
        class="text-2xs hover:bg-main-light flex h-10 flex-col items-center justify-center gap-x-3 rounded-sm transition-all duration-150 sm:flex-row sm:text-xs"
        :class="isSelected ? 'bg-main-light text-main' : ''"
      >
        <span
          class="mt-1 flex w-3 items-center justify-center text-xl sm:mt-0"
          :class="isSelected ? 'text-main' : (iconColor ?? 'text-main-text')"
        >
          <i :class="'fa-solid fa-' + icon"></i>
        </span>
        <span class="">
          <slot>{{ text }}</slot>
        </span>
        <slot name="badge-wraper">
          <span
            v-if="badge !== undefined || $slots.badge !== undefined"
            class="ml-auto flex h-6 items-center justify-center rounded-full bg-gray-200 px-2 text-sm font-semibold text-gray-500"
          >
            <slot name="badge">{{ badge }}</slot>
          </span>
        </slot>
      </div>
    </RouterLink>
  </div>
</template>

<style scoped lang="scss"></style>
